import React from 'react';

const Paginador = ({
  currentPage = 1,
  totalPages = 1,
  onPageChange
}) => {

  const irPrimera = () => onPageChange(1);

  const irAnterior = () => {
    if(currentPage > 1){
      onPageChange(currentPage - 1);
    }
  };

  const irSiguiente = () => {
    if(currentPage < totalPages){
      onPageChange(currentPage + 1);
    }
  };

  const irUltima = () => onPageChange(totalPages);

    return (
        <div>
            <button
                className="btn btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={irPrimera}
            >
                ◀◀ Primera
            </button>

            <button
                className="btn btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={irAnterior}
            >
                ◀ Anterior
            </button>

            <span className='px-3'>
                Página {currentPage} de {totalPages}
            </span>

            <button
                className="btn btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={irSiguiente}
            >
                Siguiente ▶
            </button>

            <button
                className="btn btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={irUltima}
            >
                Última ▶▶
            </button>
        </div>
    );
};

export default Paginador;